import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppProviders from "./Providers/AppProviders";
import { PostHogProvider } from '@posthog/react'

const root = ReactDOM.createRoot(document.getElementById("root"));

// Disable Chrome Translate UI
document.addEventListener("DOMContentLoaded", () => {
  const html = document.querySelector("html");
  const body = document.querySelector("body");

  if (html) html.setAttribute("translate", "no");
  if (body) body.setAttribute("translate", "no");

  // Remove any Google Translate injected elements
  const gtToolbar = document.querySelector(".goog-te-banner-frame");
  if (gtToolbar) gtToolbar.remove();

  const gtIframe = document.querySelector("iframe.goog-te-menu-frame");
  if (gtIframe) gtIframe.remove();
});

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
}

root.render(
  <React.StrictMode>
    <AppProviders>
      <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={options}
      >
        <App />
      </PostHogProvider>
    </AppProviders>
  </React.StrictMode>
);

// root.render(
//   <React.StrictMode>
//     <Provider store={Store}>
//       <LocationProvider>
//         <AuthProvider>
//           <TimetableProvider>
//             <StudentClassesProvider>
//               <CourseProvider>
//                 <HelmetProvider>
//                   <App />
//                 </HelmetProvider>
//               </CourseProvider>
//             </StudentClassesProvider>
//           </TimetableProvider>
//         </AuthProvider>
//       </LocationProvider>
//     </Provider>
//    </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
